// 말소대행 정산 항목(cancel_settlement_items) 동시 작업 프레즌스 — carPresence.js 의 createPresenceClient 팩토리 재사용.
// 서버 계약(고정): 클라 → 서버 settlement:presence:enter/leave/ping(20s)/list {itemId | itemIds[]}
//                  서버 → 클라 settlement:presence {itemId,users} / settlement:presence:snapshot {items:{id:users[]}}
// 소켓이 없으면(로그아웃 등) 전부 no-op — 서버 미배포/구 서버에서도 조용히 아무 표시 없음.
import { createPresenceClient } from './carPresence';

var settlementPresence = createPresenceClient({ eventPrefix: 'settlement:presence', idKey: 'itemId', listKey: 'itemIds', snapshotKey: 'items' });

var enter = settlementPresence.enter;
var leave = settlementPresence.leave;
var createChannel = settlementPresence.createChannel;

export { enter, leave, createChannel };
